export default [
  {
    for: 'web-series',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
];
